import React from 'react';

import {
  AgencySection,
  ManifestoSection,
  CasesSection,
  ServicesSection,
  ClientsSection,
  CategoriesAndSkills,
  MetricsSection,
} from '../../components/organisms';
import { useLanguage } from '../../contexts/LanguageContext';

import styles from './HomePage.module.css';

export const HomePage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className={styles.homepage}>
      <AgencySection />

      <ManifestoSection />

      {/* Cases Hero Title */}
      <div className={styles.casesTitleWrapper}>
        <h1 className={styles.casesHeroTitle}>{t('home.cases.title')}</h1>
      </div>

      <CasesSection />

      <ServicesSection />

      <CategoriesAndSkills />

      <ClientsSection />

      <MetricsSection className={styles.metricsBlock} />
    </div>
  );
};
